import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import './cta-section.css';

const CtaSection = () => {
    const navigate = useNavigate();

    const handleEnquireClick = () => {
        navigate('/contact');
        window.scrollTo(0, 0);
    };

    return (
        <section className="cta-section">
            <div className="cta-content">
                <div className="cta-text">
                    <h2>Ready to Find Your Dream Property?</h2>
                    <p>Contact us today for a free consultation and let our experts guide you through every step of the process.</p>
                </div>
                <div className="cta-button-wrapper">
                    <button onClick={handleEnquireClick} className="cta-button">
                        ENQUIRE NOW
                        <FaArrowRight className="arrow-icon" />
                    </button>
                </div>
            </div>
        </section>
    );
};

export default CtaSection;
